<template>

  <div class="wrapper">
    <div class="sidebar" data-color="blue" data-image="../assets/img/sidebar-5.jpg">
      <!--
          Tip 1: You can change the color of the sidebar using: data-color="purple | blue | green | orange | red"

          Tip 2: you can also add an image using data-image tag
      -->
      <div class="sidebar-wrapper">
        <div class="logo">
          <a href="#" class="simple-text logo-mini">R</a>
          <a href="#" class="simple-text logo-normal">RAEFTON</a>
        </div>

        <ul class="nav">
          <li class="nav-item">
            <a class="nav-link" href="/raw_templates/t_dashboard">
              <i class="nc-icon nc-delivery-fast"></i>
              <p>RFQs</p>
            </a>
          </li>
          <li class="nav-item active ">
            <a class="nav-link" href="/raw_templates/t_createrfq">
              <i class="nc-icon nc-paper-2"></i>
              <p>CREATE RFQ</p>
            </a>
          </li>
          <li class="nav-item ">
            <a class="nav-link" href="/raw_templates/t_contacts">
              <i class="nc-icon nc-circle-09"></i>
              <p>CONTACTS</p>
            </a>
          </li>

        </ul>
      </div>
      <div class="sidebar-background" style="background-image: url(/static/img/sidebar-5.jpg) "></div>
    </div>
    <div class="main-panel">
      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg ">
        <div class="container-fluid">
          <div class="navbar-wrapper">
            <div class="navbar-minimize">
              <button id="minimizeSidebar" class="btn btn-primary btn-fill btn-round btn-icon d-none d-lg-block">
                <i class="fa fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i class="fa fa-navicon visible-on-sidebar-mini"></i>
              </button>
            </div>
            <a class="navbar-brand" href="#pablo">Create RFQ</a>
          </div>
          <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
          </button>

        </div>
      </nav>
      <!-- End Navbar -->
      <div class="content">
        <div class="row">
          <div class="col-12">

            <div class="card">
              <div class="card-header">
                <h4 class="card-title">RFQ Customer Details</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-3 border-right">
                    <h5>Customer</h5>
                    <p><small class="text-muted">Company / Name</small><br>Brian G. Baldree</p>
                    <p><small class="text-muted">Address</small><br>86 Edwin Street<br>Kitchener, Ontario<br>K0A 2N0<br>Canada</p>
                    <p><small class="text-muted">Terms</small><br>EXW Ex-Works</p>
                    <p><small class="text-muted">Due Date</small><br>11/01/2018</p>
                  </div>
                  <div class="col-12 col-sm-3 border-right">
                    <h5>Shipper</h5>
                    <p><small class="text-muted">Company / Name</small><br>Katherine C. Hinkle</p>
                    <p><small class="text-muted">Address</small><br>88 Martin St<br>Kitchener, Ontario<br>K0A 2N0<br>Canada</p>
                    <p><small class="text-muted">Appointment</small><br>No</p>
                    <p><small class="text-muted">Pick Up Date</small><br>11/01/2018 12:00</p>
                  </div>
                  <div class="col-12 col-sm-3 border-right">
                    <h5>Consignee</h5>
                    <p><small class="text-muted">Company / Name</small><br>Brandy Kersey</p>
                    <p><small class="text-muted">Address</small><br>99 James Street<br>Kitchener, Ontario<br>K0A 2N0<br>Canada</p>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Appointment</small><br>No</p></div>
                      <div class="col-6"><p><small class="text-muted">COD</small><br>No</p></div>
                    </div>
                    <p><small class="text-muted">Delivery</small><br>11/01/2018 12:00</p>
                  </div>
                  <div class="col-12 col-sm-3">
                    <h5>Truck</h5>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Trailer Type</small><br>Dry Van</p></div>
                      <div class="col-6"><p><small class="text-muted">Suspension Type</small><br>Spring</p></div>
                    </div>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Temperature Control</small><br>Reefer Fresh</p></div>
                      <div class="col-6"><p><small class="text-muted">Lift Gate</small><br>Yes</p></div>
                    </div>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Driver Assist</small><br>Yes</p></div>
                      <div class="col-6"><p><small class="text-muted">Mode</small><br>FTL</p></div>
                    </div>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Service</small><br>Overnight</p></div>
                      <div class="col-6"><p><small class="text-muted">Dunnage Required</small><br>1.5 l/ cu-ft</p></div>
                    </div>
                    <p><small class="text-muted">Special Instructions</small><br>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsa vitae repellat hic a autem quam maxime laudantium quisquam. Itaque soluta rem veritatis, natus velit eum dolorem quos recusandae! Nam, eum.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Assignees</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Due Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>John Valence</td>
                          <td>11/02/2018</td>
                          <td class="text-right"><button class="btn btn-icon btn-xs btn-danger"><i class="fa fa-minus"></i></button></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-group">
                              <input type="text" id="assignee_name" class="form-control">
                            </div>
                          </td>
                          <td>
                            <div class="form-group">
                              <input id="datetimepicker" type="text" class="form-control datetimepicker" >
                            </div>
                          </td>
                          <td class="text-right"><button class="btn btn-icon btn-xs btn-success"><i class="fa fa-plus"></i></button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Quotes</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Quote Author</th>
                          <th>Cost</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>John Valence</td>
                          <td>N/A</td>
                          <td class="text-right"><button class="btn btn-icon btn-xs btn-success">Finish Quote</button></td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="d-block text-center"><button class="btn btn-icon btn-xs btn-primary">Add Quote</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card data-tables">
                <div class="card-body table-no-bordered dataTable dtr-inline table-full-width">
                    <div class="toolbar">
                        <!-- Here you can write extra buttons/actions for the toolbar -->
                    </div>
                    <div class="fresh-datatables">
                        <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                          <thead>
                            <tr>
                              <th class="disabled-sorting"></th>
                              <th>Description</th>
                              <th>Type</th>
                              <th>Quantity</th>
                              <th>Length</th>
                              <th>Width</th>
                              <th>Height</th>
                              <th>Stackable</th>
                              <th>Units</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>#1</td>
                              <td>1 item in inches</td>
                              <td>imperial type walker</td>
                              <td>1</td>
                              <td>304.8</td>
                              <td>304.8</td>
                              <td>304.8</td>
                              <td>Yes</td>
                              <td>mm/g</td>
                            </tr>
                            <tr>
                              <td>#2</td>
                              <td>1 item 900 grams</td>
                              <td>metric type x-wing</td>
                              <td>1</td>
                              <td>12</td>
                              <td>12</td>
                              <td>12</td>
                              <td>Yes</td>
                              <td>mm/g</td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn-primary btn-wd"><i class="fa fa-chevron-left"></i> Back</button>
        </div>
      </div>
      <footer class="footer">
        <div class="container">
          <nav>
            <p class="copyright text-center">
              &copy; 2018 Raefton
            </p>
          </nav>
        </div>
      </footer>
    </div>
  </div>


</template>

<script>
  import router from '../../router'
  import apiService from '../../services/api.service'
  import config from '../../config'


  export default {
    name: 'Demo',
    data: function() {
      return {
        user: '',
        password: '',
        myname: 'Timmyy',
      }
    },
    mounted: function() {
      console.log("mounted");
    },
    methods: {


    }
  }



  function initTables() {
    $('#datatables').DataTable({
      "pagingType": "full_numbers",
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      }

    });

    console.log("datatables init done!");

    $('.datetimepicker').datetimepicker({
      icons: {
        time: "fa fa-clock-o",
        date: "fa fa-calendar",
        up: "fa fa-chevron-up",
        down: "fa fa-chevron-down",
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-screenshot',
        clear: 'fa fa-trash',
        close: 'fa fa-remove'
      }
    });
  }



  // https://vuejsdevelopers.com/2017/04/22/vue-js-libraries-plugins/
  // https://laracasts.com/discuss/channels/vue/using-datatables-with-vue
  // setTimeout(initCharts, 1200);
  // setTimeout(initTables, 1400);
</script>



// WEBPACK FOOTER //
// t_viewrfq.vue?dc26cdd4